import Model from '../Model';
import DistributionModel from './DistributionModel';

export default class BundleModel extends Model {

    constructor(data) {
        super(data);
        this.name = data.name;
        this.latest_version = data.latest_version;
        this.permissions = data.permissions || [];
        if (data.latest_version && data.latest_version.last_distributions) {
            this.latest_version.last_distributions = data.latest_version.last_distributions.map((distribution) => {
                return new DistributionModel(distribution);
            });
        }
        if (data.versions) {
            this.versions = data.versions.map(version => version.version);
        }
        this.tableId = data.name;
        if (data.latest_version && data.latest_version.name) {
            this.tableId += data.latest_version.name;
        }

        if (!this.latest_version ||
            !this.latest_version.last_distributions ||
            !this.latest_version.last_distributions.length) {
            return;
        }

        const lastDistributions = this.latest_version.last_distributions;
        this.latest_version.distribution = lastDistributions[0];
    }
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/BundleModel.js